//
import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import {ModuleCode, SelectCertificateField as SelectCertificateFieldX} from "@mc/react-sign";
import SignApi from "../../api/gen/qsign/SignApi";
import CustomSignApi from "../../api/gen/qsign/CustomSignApi";
import "./QSelectCertificateField.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCertificate } from "@fortawesome/free-solid-svg-icons";
import {isWindows} from "../../utils/appUtils";
class QSelectCertificateField extends Component {
  componentDidUpdate(prevProps) {
    const { value, onChange } = this.props;

    if (
      value &&
      prevProps.value &&
      value.thumbprint === prevProps.value.thumbprint &&
      value.validTo &&
      new Date(value.validTo) < new Date()
    ) {
      onChange(null);
    }
  }

  render() {
    const { value, onChange, disabled, viewId, onLoading, onCertsLoaded, onActiveModules, ...other } = this.props;
    let valueName = "";

    if (value) {
      valueName = value.name;
    }

    const onFailLoading = false;
    const autoloading = true;
    const autoselect = false;
    const forceAutoselect = true;
    return (
      <SelectCertificateFieldX
        className={"select-cert-field fa-own-style own-button"}
        value={value}
        onFailLoading={(msg, e) => {
          if (onFailLoading) {
            onFailLoading(msg, e);
          } else {
            console.error(msg, e);
          }
        }}
        getCerts={(requestId) => {
          console.log("call getCerts", requestId, viewId);
          return CustomSignApi.getCertificatesCustom(requestId, viewId, !isWindows()).then(certs => {
              let exists = false;
              let cname = "";
              if (this.props.value) {
                  cname = this.props.value.name;
              }
              certs.forEach(cert => {
                  if (cert.name === cname) {
                      exists = true;
                  }
              });
              if (!exists && cname !== "") {
                  if (onChange) {
                      onChange(null);
                  }
              }
              onCertsLoaded && onCertsLoaded(certs, requestId);
              return certs;
          });
        }}
        getActiveModules={() => {
          console.log("call getActiveModules");
          return SignApi.getActiveModules().then(modules => {
              if (isWindows()) {
                  onActiveModules && onActiveModules(modules);
                  return modules;
              } else {
                  console.log("call getActiveModules - filter MARBES type", modules);
                  const updateModules = modules.filter(m => m !== ModuleCode.MARBES);
                  console.log("call getActiveModules - filtered MARBES type", updateModules);
                  onActiveModules && onActiveModules(updateModules);
                  return updateModules;
              }
          });
        }}
        onChange={(cert) => {
          if (onChange) {
            onChange(cert);
          } else {
            console.log("selected", cert);
          }
        }}
        onLoading={(state) => {
          if (onLoading) {
            onLoading(state);
          } else {
            console.log("loading cert: " + state);
          }
        }}
        renderCertContent={(item) => {
          return (
            item && (
              <Row noGutters className="cert-item align-items-center py-2 ">
                <Col className="px-2">
                  <FontAwesomeIcon size={"2x"} className={"m-1"} icon={faCertificate} />
                </Col>
                <Col xs={"auto"}>
                  <div>{item.name}</div>
                  {item.issuer && item.issuer !== item.name && <div>{item.issuer}</div>}
                </Col>
              </Row>
            )
          );
        }}
        autoloading={autoloading}
        disabled={disabled}
        autoselect={autoselect}
        forceAutoselect={forceAutoselect}
      />
    );
  }
}

export default connect()(QSelectCertificateField);
